import { ButtonProtected, ProcessingScreen } from '@components'

import { ModuleLayout } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { QuotesList as QuotesListFeature } from '@features/invoices/elements/QuotesList'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useHasQuotes } from '@features/invoices/hooks/useHasQuotes'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { Scope } from '../../../../enums/scope'
import { TableIds } from '../../../../enums/tableIds'
import { TrackingContext } from '../../../../enums/trackingContext'
import { useSegment } from '../../../../hooks'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { QuotesListEmpty } from './elements/QuotesListEmpty'

const quoteDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Quote)

export const QuotesList = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { hasQuotes, isFetching } = useHasQuotes({})
  const { url: quoteNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(quoteDocumentRouteBase),
  )

  const handleCreateQuoteClick = useCallback(() => {
    track('XXX - Invoicing Core - Quotes List - Create new quote clicked')
  }, [track])

  if (isFetching) {
    return <ProcessingScreen />
  }

  return (
    <ModuleLayout
      title={t('quotes')}
      sideActions={
        hasQuotes ? (
          <ButtonProtected
            icon="circlePlus"
            onClick={handleCreateQuoteClick}
            scopes={Scope.OfferWrite}
            to={quoteNewUrl}
            trackingContext={TrackingContext.CreateQuote}
          >
            {t('quotes.side_actions.create_quote')}
          </ButtonProtected>
        ) : null
      }
    >
      {hasQuotes ? (
        <QuotesListFeature newDocumentUrl={quoteNewUrl ?? ''} tableId={TableIds.QuotesTable} />
      ) : (
        <QuotesListEmpty quoteNewUrl={quoteNewUrl} />
      )}
    </ModuleLayout>
  )
}
